import { ReactNode, useContext, useId } from "react";
import CursorProvider, { CursorContext, CursorState } from "../../providers/CursorProvider";

export class CursorComponentProps
{
    cursor : CursorState = CursorState.STD;
    onClick : any = () => {};
    children : ReactNode;
    stdOnClick ?: any = () => {};
    className ?: string;
    style ?: React.CSSProperties;
    id ?: string;
}

export function CursorComponent (props: CursorComponentProps) {
    const id = props.id !== undefined ? props.id : useId();
    const cursorContext = useContext<CursorContext>(CursorProvider.context);

    const className = props.className !== undefined ? props.className : '';
    const style = props.style !== undefined ? props.style : {};

    const clickFunction = () => {
        if (cursorContext.state != props.cursor)
        {
            if (props.stdOnClick !== undefined)
                props.stdOnClick();
            return;
        }
    
        props.onClick();
    };

    return <div onClick={clickFunction} id={id} className={className} style={style}>
        { props.children }
    </div>
}